import { range, pipe } from 'ramda';
import { subDays, addDays, format, addMonths, isWithinRange } from 'date-fns';

export const getWeekDays = ({
  weekStartsOn = 0,
  format = undefined,
  weekLength = 7
} = {}) => {
  const today = new Date();
  const difference = today.getDay() - weekStartsOn;
  const startDay = difference > 0 ?
    subDays(today, difference)
    : addDays(today, difference);
  return range(0, weekLength)
    .map((e, i) => addDays(startDay, i))
    .map(d => {
      if (format) {
        return format(d, format)
      } else {
        return d;
      }
    });
}


export const DateObj = {
  getObjFromDate: (date) => {
    return {
      month_val: format(date, 'YYYYMM'),
      year: format(date, 'YYYY'),
      month: format(date, 'MMMM'),
    };
  },
  toMMMMYYYY: ({ month, year }) => {
    return `${toMonthName(month)} ${year}`;
  },
  toYYYYMM: ({ month, year }) => {
    return `${year}-${padWithZero(month)}`;
  }
}


export const getNextMonths = ({
  from = new Date(),
  length = 12,
  inputFormat = 'YYYY-MM',
  outputFormat = undefined
} = {}) => {
  const startFrom = format(from, inputFormat);
  return range(0, length)
    .map(e => {
      return addMonths(startFrom, e);
    })
    .map(e => {
      if (outputFormat) {
        return format(e, outputFormat);
      } else {
        return e;
      }
    });
}

export const MONTH_NAMES = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

export const getMonthNumber = (monthName) => MONTH_NAMES.findIndex(e => e == monthName) + 1;
export const getMonthIndex = (monthName) => MONTH_NAMES.findIndex(e => e == monthName);

export const dateFromObj = (obj) => {
  return new Date(obj.year, getMonthIndex(obj.month));
}

export const getYearMonthH = (date) => {
  return format(date, 'YYYY-MM');
}

export const getDefaultDateString = (date) => {
  return format(date, 'YYYY-MM-DD');
}

export const getYearMonthHFromObj = pipe(dateFromObj, getYearMonthH);

// console.log(getWeekDays({ format: 'ddd' }));
// console.log(getNextMonths());
// console.log(new Date('2000-01-02'))

export const isWithinRangeTolerant = (day, startDate, endDate) => {
  startDate = new Date(startDate);
  endDate = new Date(endDate);
  if (startDate.getTime() > endDate.getTime()) {
    console.error(`End Date ${endDate} is after Start Date ${startDate} !`);
    endDate = startDate;
  }
  return isWithinRange(day, startDate, endDate);
}

// console.log(isWithinRangeTolerant(new Date('2000-01-05'), new Date('2000-01-05'), new Date('2000-01-01')));

// try {
//   let d = isWithinRange(new Date('2000-01-05'), new Date('2000-01-05'), new Date('2000-01-01'))
// }catch(e) {
//   if (e.message === `The start of the range cannot be after the end of the range`) {

//     console.log('Range ERR')
//   }
// }

/** Converts a String of Type yyyy-mm-dd to a Proper UTC Date -> Which may come out as the Previous Date in UTC/GMT London Time */
export const getUTCDateFromString = (string) => {
  const date = new Date(string);
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}


export const padWithZero = (value, length = 2) => {
  return `${value}`.padStart(length, "0");
}

export const getValidHour = (value = 0) => {
  return value > 23 ? 0 : value < 0 ? 23 : value;
}
export const getValidMinSec = (value = 0) => {
  return value > 59 ? 0 : value < 0 ? 59 : value;
}


export const getCurrentYear = () => {
  console.log({ 'calendar.js:121 getCurrentYear': 1 });
  return (new Date()).getFullYear();
}
export const getCurrentHalfYear = () => {
  console.log({ 'calendar.js:124 getCurrentHalfYear': 1 });
  return ((new Date()).getMonth() + 1) / 6 > 1 ? 1 : 0;
}
/**
 * @param  {} mos='202205'
 * Converts the Month String to a Hyphenated Form YYYY-MM
 */
export const hyphenateMonthString = (mos = '202205') => {
  return [
    ...mos.substring(0, 4),
    '-',
    ...mos.substring(4, 6),
  ].join('');
}



/**
 * @param  {string} month
 * @param  {number} offset
 * 
 * @description Adds the Offset to the String Format MonthDate YYYY-MM
 * Use this Function to Add months or Substract month from such a MonthString
 * @example navigateFromMonthString(`2022-12`, 1) => 2023-01
 * @example navigateFromMonthString(`2022-12`, -1) => 2022-11
 */
export function navigateFromMonthString(month, offset = 1) {
  const monthDate = getDateFromYearMonthHF(month);

  const nextMonth = addMonths(monthDate, offset);

  const nextMonthString = `${nextMonth.getFullYear()}-${padWithZero(nextMonth.getMonth() + 1)}`;

  return nextMonthString;
}
/**
 * @param  {string} month='2022-05'
 * Returns a Javascript Date Object from a Hypenated Date YearMonth String 
 * @input Format is YYYY-MM
 * @output Format is `Date()` Object  
 */
function getDateFromYearMonthHF(month = '2022-05') {
  console.log({ 'calendar.js:163 month': month });
  const monthDateSplit = month.split('-');
  const monthDate = new Date(Number(monthDateSplit[0]), Number(monthDateSplit[1]) - 1);
  return monthDate;
}

/**
 * @param {String} YearMonthHF='2022-05'
 * @returns  {year: month} getObjFromDate
 */
export const getObjFromYearMonthHF = pipe(getDateFromYearMonthHF, DateObj.getObjFromDate);

/**
 * Returns a string representing the timezone offset in the format -HH:mm or +HH:mm.
 * @returns {string} The timezone offset string.
 */
export function getTimezoneOffsetString() {
  const now = new Date();
  const offsetMinutes = now.getTimezoneOffset();
  const offsetHours = Math.abs(Math.floor(offsetMinutes / 60));
  const offsetMinutesRemainder = Math.abs(offsetMinutes % 60);
  const offsetSign = offsetMinutes < 0 ? '+' : '-';
  const offsetString = `${offsetSign}${offsetHours.toString().padStart(2, '0')}:${offsetMinutesRemainder.toString().padStart(2, '0')}`;
  return offsetString;
}

// Get the time zone offset in minutes for the current date
export function getTimezoneOffsetMilliseconds(date) {
  // If Date is not valid, use the current date and time
  if (!(date instanceof Date) || isNaN(date)) {
    date = new Date();
  }

  const offsetMinutes = date.getTimezoneOffset();

  const offsetMilliseconds = offsetMinutes * 60000;

  return offsetMilliseconds;
}

/**
 * Adjusts the input date to the local time zone by adding the time zone offset in milliseconds.
 * @param {Date} date The input date to adjust.
 * @returns {Date} The adjusted date in the local time zone.
 */
export function adjustToLocal(date) {
  let offsetMilliseconds = getTimezoneOffsetMilliseconds(date);
  // if (offsetMilliseconds >= 0) {
  //   offsetMilliseconds *= -1; 
  // }
  const adjustedDate = new Date(date.getTime() + offsetMilliseconds);

  return adjustedDate;
}

/**
 * Returns the Date Object from the Date String with the Timezone Offset
 * Ensure that the date string is in the format YYYY-MM-DD
 * @param {string} dateString
 */
export function getDateFromDateStringWithTZ(dateString) {
  if (!dateString) {
    return null;
  }
  if (dateString.length !== 10) {
    throw new Error(`Invalid date string ${dateString}`);
  }
  const timezoneOffsetString = getTimezoneOffsetString();
  const date = new Date(`${dateString}T00:00:00${timezoneOffsetString}`);
  return date;
}
/**
 * Returns the Date Object from the Date String with the Timezone Offset
 * Ensure that the date string is in the format YYYY-MM-DD
 * @param {string} dateString
 */
export function parseUTCDate(dateString) {
  if (!dateString) {
    return null;
  }
  if (dateString.length !== 10) {
    throw new Error(`Invalid date string ${dateString}`);
  }

  // Parse the date string into a Date object
  const date = new Date(dateString);

  // Get the UTC timestamp for the date
  const utcTimestamp = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());


  return new Date(utcTimestamp);
}

export function startOfWeek(date, options = {
  weekStartsOn: 1,
}) {
  // Get the week start day and number of days per week from the options
  const { weekStartsOn } = options;
  console.log({ 'calendar.js:237 options': options });

  // Calculate the number of days since the start of the week
  const dayOfWeek = date.getUTCDay();
  const daysSinceStartOfWeek = (dayOfWeek - weekStartsOn + 7) % 7;

  // Calculate the start date of the week in UTC
  const utcTimestamp = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate() - daysSinceStartOfWeek);
  const startOfWeek = new Date(utcTimestamp);

  // Return the start date of the week in UTC
  return startOfWeek;
}
export function startOfMonth(date) {
  const utcTimestamp = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), 1);

  const startOfMonth = new Date(utcTimestamp);

  return startOfMonth;
}

export const UTC_0_HOUR = `T00:00:00Z`;


export function addDaysUTC(date, days) {
  const utcTimestamp = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate() + days);

  const newDate = new Date(utcTimestamp);

  return newDate;
}

/**
 * Returns the GMT offset and timezone of the system in a human-readable way.
 * @returns {string} The GMT offset and timezone of the system in a human-readable way.
 */
export function getGMTOffsetText(date) {
  // If Date is not valid, use the current date and time
  if (!(date instanceof Date) || isNaN(date)) {
    date = new Date();
  }
  // Get the time zone offset in minutes for the current date and time
  const offsetMinutes = date.getTimezoneOffset();

  // Convert the offset to the desired format
  const sign = offsetMinutes < 0 ? '+' : '-';
  const hours = Math.abs(Math.floor(offsetMinutes / 60));
  const minutes = Math.abs(offsetMinutes % 60);
  const offsetText = `${sign}${padWithZero(hours)}:${padWithZero(minutes)}`;

  // Get the time zone name for the current date and time
  const timeZoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // Return the GMT offset and timezone in a human-readable way
  return `GMT${offsetText} (${timeZoneName})`;
}


/**
 * Resets the hour of a date in UTC format.
 */
export function resetHourOfUTCDate(date) {
  date = new Date(date.getTime());
  date.setUTCHours(0, 0, 0, 0);
  return date;
}



/**
 * Returns the month of a date in 'MMM' format.
 */
export function getMonthInMMMFormat(inputDate) {
  const date = new Date(inputDate.getTime());

  const monthNames = [
    'jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', "dec"
  ]

  const month = date.getUTCMonth();

  return monthNames[month];
}

/**
 * Returns the month of a date in 'MMMM' format.
 */
export function getMonthInMMMMFormat(inputDate) {
  const date = new Date(inputDate.getTime());

  const monthNames = [
    'january', 'february', 'march', 'april', 'may', 'june', 'july', 'august',
    'september', 'october', 'november', "december"
  ]

  const month = date.getUTCMonth();

  return monthNames[month];
}

/**
 * Returns the weekday of a date in 'ddd' format.
 */
export function getWeekdayIndddFormat(inputDate) {
  // Parse the date string into a Date object
  const date = new Date(inputDate.getTime());

  // Array of weekday abbreviations in lowercase
  const weekdayNames = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

  // Get the weekday of the date
  const weekday = date.getUTCDay();

  // Return the weekday in 'ddd' format
  return weekdayNames[weekday];
}


// Generates an array of month and year objects between start and end
export function generateMonthYearArray(start, end) {
  const startDate = new Date(start.year, getMonthIndex(start.month) - 1); // JavaScript months are 0-based
  console.log({ 'calendar.js:388 startDate': startDate });
  const endDate = new Date(end.year, getMonthIndex(end.month) - 1);
  console.log({ 'calendar.js:390 endDate': endDate });
  const result = [];

  while (startDate <= endDate) {
    result.push({ month: startDate.getMonth() + 1, year: startDate.getFullYear() });
    startDate.setMonth(startDate.getMonth() + 1);
  }

  console.log({ 'calendar.js:399 result': result });
  return result;
}

export const toMonthName = (month) => {
  return MONTH_NAMES[month - 1];
}

// max_date	"2024-01-25"
// min_date	"2022-10-25"
export const getMonthYearTVsFromMinMaxObject = ({ min_date, max_date } = {
  min_date: '1970-01-01',
  max_date: '1970-01-01'
}) => {
  const min = DateObj.getObjFromDate(new Date(min_date));
  const max = DateObj.getObjFromDate(new Date(max_date));

  console.log({ min, max });

  if (new Date(min_date) === 'Invalid Date' || new Date(max_date) === 'Invalid Date') {
    console.log(`Invalid Date ${min_date} or ${max_date} !`)
    return [];
  }

  return generateMonthYearArray(min, max)?.map(e => ({
    text: DateObj.toMMMMYYYY(e),
    value: DateObj.toYYYYMM(e)
  })) || [];
}